<style lang="scss" scope>
.ivu-mt,
.ivu-mt-16 {
    margin-top: 16px !important;
}

.items-center {
    align-items: center;
}

.justify-between {
    justify-content: space-between;
}

.flex {
    display: flex !important;
    width: 100%;
}

.flex-warp {
    flex-wrap: wrap;
}

.mr1 {
    margin-right: 1rem;
    word-wrap: +break-word;
    word-break: +norm;
}

.flexs {
    display: flex !important;
    width: 15%;
}
</style>
<template>
    <!-- <el-card shadow="never" class="l-main-card"> -->
    <div class="l-edit-dialog-box">
        <div class="l-table-app-user">
            <div class="flex flex-warp">
                <div class="flexs items-center ivu-mt ivu-mr">
                    <p class="mr1">用户ID：</p>
                    <el-input placeholder="请输入员工Id" v-model="search_data.app_user_id" class="input-with-select"
                        style="width: 76%;">
                        <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
                    </el-input>
                </div>

                <div class="flexs items-center ivu-mt ivu-mr">
                    <p class="mr1">员工名：</p>
                    <el-input placeholder="请输入员工名" v-model="search_data.admin_name" class="input-with-select"
                        style="width: 76%;">
                        <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
                    </el-input>
                </div>

                <!-- <div class="flexs items-center ivu-mt ivu-mr">
                    <p class="mr1">所属APP：</p>
                    <div class="l-show-more-search">
                        <el-select v-model="search_data.app_type" placeholder="全部" clearable @change="changes"
                            style="width: 100%;">
                            <el-option v-for="item in []" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div> -->
                <div class="flexs items-center ivu-mt ivu-mr">
					<p class="mr1">优质用户：</p>
					<div class="l-show-more-search">
						<el-select v-model="search_data.is_vip" placeholder="全部" clearable @change="changes">
							<el-option v-for="item in is_vip" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</div>
				</div>

                <div class="flexs items-center ivu-mt ivu-mr">
                    <p class="mr1">排查日期</p>
                    <div class="l-show-more-search" style="width: 76%;">
                        <el-date-picker v-model="value2" type="datetimerange" @blur="onPick(false)"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                            @change="onPick(false)"></el-date-picker>
                    </div>
                </div>

            </div>
        </div>
        <l-table :data="data" v-loading="loading" row-key="id" style=" max-height: 56vh;">
            <el-table-column fixed prop="index" label="序号" width="80"> </el-table-column>
            <el-table-column prop="admin_name" label="员工名" min-width="160"> </el-table-column>
            <el-table-column prop="DisplayId" label="用户ID" min-width="200"> </el-table-column>
            <el-table-column prop="user_name" label="用户昵称" min-width="200"> </el-table-column>
            <el-table-column prop="recharge_total" label="用户充值" min-width="160"> </el-table-column>
            <el-table-column prop="guild_recharge_total" label="公会代充" min-width="160"> </el-table-column>
            <el-table-column prop="OnlineTime" label="最近在线时间" min-width="200"> </el-table-column>
            <el-table-column prop="bind_time" label="绑定时间" min-width="180"> </el-table-column>
            <el-table-column prop="room_code" label="房间ID" min-width="160"> </el-table-column>
            <el-table-column prop="register_time" label="注册时间" min-width="200"> </el-table-column>
            <el-table-column prop="bind_type" label="绑定方式" min-width="120">
                <template slot-scope="{ row }">
                    {{ BIND_TYPE[row.bind_type] }}
                </template>
            </el-table-column>
            <el-table-column prop="bind_status" label="绑定状态" min-width="120">
                <template slot-scope="{ row }">
                    {{ BIND_STATUS[row.bind_status] }}
                </template>
            </el-table-column>
            <el-table-column prop="is_main" label="用户类型" min-width="120">
                <template slot-scope="{ row }">
                    {{ IS_MIAN[row.is_main] }}
                </template>
            </el-table-column>
            <el-table-column prop="refuse_text" label="绑定原因" min-width="160"> </el-table-column>
            <el-table-column prop="user_pay_total" label="用户流水" min-width="160"> </el-table-column>
     
            <el-table-column prop="admin_recharge_total" label="后台充值" min-width="160"> </el-table-column>
            <el-table-column prop="app_id" label="APP类型" min-width="120">
                <template slot-scope="{ row }">
                    {{ APP_TYPE[row.app_id] }}
                </template>
            </el-table-column>
         
          
            <el-table-column prop="created_at" label="创建时间" min-width="180"> </el-table-column>
        </l-table>

        <!--分页-->
        <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
            :current-page.sync="page"></l-page>
        <!-- </el-card> -->
    </div>
</template>

<script>

import { APP_TYPE, BIND_TYPE, IS_MIAN, BIND_STATUS } from "../appUser/state";
// import Vue from "vue";
export default {
    name: "l-user-achievemet-corp",
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
        visible: {
            type: Boolean,
        },
        valueData: {
            type: [Map, String],
            default: null,
        }
    },
    data() {
        return {
            is_vip: [
				{ "id": 0, "name": "否" },
				{ "id": 1, "name": "是" }
			],
            data: [],
            count: 0,
            page: 1,
            page_size: 10,
            loading: false,
            APP_TYPE: APP_TYPE,
            BIND_TYPE: BIND_TYPE,
            IS_MIAN: IS_MIAN,
            BIND_STATUS: BIND_STATUS,
            //搜索
            search_visible: false,
            search_data: {
                app_user_id: "",
                app_type: "",
                corp_id: "",
                depart_id: "",
                group_id: "",
                admin_name: "",
                bind_type: "",
                bind_status: "",
                app_user_brisk: "",
                is_vip: "",
                start_time: "",
                end_time: ""
            },
            rel_search_data: {},
            show_more_search: false,
            value2: "",
            value2_check: "",
            // corp_list: [],
            // depart_list: [],
            // group_list: [],
            app_list: []
        };
    },
    // mounted() {

    // },

    watch: {
        visible: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.timeStart();
                    this.getList();
                }
            },
        },
    },


    methods: {
        timeStart() {
            if (!this.$props.valueData) {
                this.$props.valueData = "";
                this.search_data.start_time = "";
                this.search_data.end_time = "";
            } else {
                this.value2 =this.$props.valueData
                this.search_data.start_time = this.$props.valueData[0];
                this.search_data.end_time = this.$props.valueData[1];
            }
        },
        // 点击 更改部门
        changes() {
            this.getList();
        },
        onPick(cant) {
            if (!this.value2) {
                this.value2 = "";
                this.search_data.start_time = "";
                this.search_data.end_time = "";
            } else {
                this.search_data.start_time = this.value2[0];
                this.search_data.end_time = this.value2[1];
            }
            if (!cant) {
                this.onSearch();
            }
        },
        //获取数据
        getList() {
            this.loading = true;
            this.$_invoke("appUser_getList", {
                page: this.page,
                page_size: this.page_size,
                org_id_s: this.$props.id,
                org_type_s: 2,
                ... this.search_data,
            })
                .then((ret) => {
                    this.data = ret.data;
                    this.count = ret.count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        //点击搜索按钮
        onSearch() {
            this.page = 1;
            this.rel_search_data = this.search_data;
            this.getList();
        },

        //点击重置搜索框
        clearSearch() {
            this.corp_list = [];
            this.depart_list = [];
            this.group_list = [];
            this.app_list = [];
            this.$refs.search_form.resetFields();
            this.rel_search_data = {};
        },

        //页码改变
        pageChange(page) {
            this.page = page;
            this.getList();
        },

        //每页显示条数改变
        pageSizeChange(page_size) {
            this.page_size = page_size;
            this.getList();
        },
    },
};
</script>
